export default __webpack_public_path__ + "static/media/mapMetk.391c7cc1.svg";